/*!
 * 
 *   @bornfight/gocart v1.0.9
 *   
 * 
 *   Copyright (c) Bornfight (https://www.bornfight.com/)
 * 
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *	Add Multiple Triggers
 *   
 */


class GoCart {

    constructor(options) {

        const defaults = {
            cartModalFail: '.js-go-cart-modal-fail',
            cartModalFailClose: '.js-go-cart-modal-fail-close',
            cartModal: '.js-go-cart-modal',
            cartModalClose: '.js-go-cart-modal-close',
            cartModalContent: '.js-go-cart-modal-content',
            cartModalItems: '.go-cart-item__single',
            cartDrawer: '.js-go-cart-drawer',
            cartDrawerContent: '.js-go-cart-drawer-content',
            cartDrawerSubTotal: '.js-go-cart-drawer-subtotal',
            cartDrawerFooter: '.js-go-cart-drawer-footer',
            cartDrawerClose: '.js-go-cart-drawer-close',
            cartMiniCart: '.js-go-cart-mini-cart',
            cartMiniCartContent: '.js-go-cart-mini-cart-content',
            cartMiniCartSubTotal: '.js-go-cart-mini-cart-subtotal',
            cartMiniCartFooter: '.js-go-cart-mini-cart-footer',
            cartTrigger: '.js-go-cart-trigger',
            cartOverlay: '.js-go-cart-overlay',
            cartCount: '.js-go-cart-counter',
            addToCart: '.js-go-cart-add-to-cart',
            removeFromCart: '.js-go-cart-remove-from-cart',
            removeFromCartNoDot: 'js-go-cart-remove-from-cart',
            itemQuantity: '.js-go-cart-quantity',
            itemQuantityPlus: '.js-go-cart-quantity-plus',
            itemQuantityMinus: '.js-go-cart-quantity-minus',
            cartMode: 'drawer',
            drawerDirection: 'right',
            displayModal: false,
            // eslint-disable-next-line no-template-curly-in-string
            moneyFormat: '${{amount}}',
            labelAddedToCart: 'was added to your cart.',
            labelCartIsEmpty: 'Your Cart is currently empty!',
            labelQuantity: 'Quantity:',
            labelRemove: 'Remove',
            hiddenItemTag: 'hidden-product',
        };

        this.defaults = Object.assign({}, defaults, options);

        this.cartModalFail = document.querySelector(this.defaults.cartModalFail);
        this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose);
        this.cartModal = document.querySelector(this.defaults.cartModal);
        this.cartModalClose = document.querySelectorAll(this.defaults.cartModalClose);
        this.cartModalContent = document.querySelector(this.defaults.cartModalContent);
        this.cartDrawer = document.querySelector(this.defaults.cartDrawer);
        this.cartDrawerContent = document.querySelector(this.defaults.cartDrawerContent);
        this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal);
        this.cartDrawerFooter = document.querySelector(this.defaults.cartDrawerFooter);
        this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose);
        this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart);
        this.cartMiniCartContent = document.querySelector(this.defaults.cartMiniCartContent);
        this.cartMiniCartSubTotal = document.querySelector(this.defaults.cartMiniCartSubTotal);
        this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter);
        this.cartTrigger = document.querySelectorAll(this.defaults.cartTrigger);
        this.cartOverlay = document.querySelector(this.defaults.cartOverlay);
        // this.cartCount = document.querySelector(this.defaults.cartCount);
        this.cartCount = document.querySelectorAll(this.defaults.cartCount);
        this.addToCart = document.querySelectorAll(this.defaults.addToCart);
        this.removeFromCart = this.defaults.removeFromCart;
        this.removeFromCartNoDot = this.defaults.removeFromCartNoDot;
        this.itemQuantity = this.defaults.itemQuantity;
        this.itemQuantityPlus = this.defaults.itemQuantityPlus;
        this.itemQuantityMinus = this.defaults.itemQuantityMinus;
        this.cartMode = this.defaults.cartMode;
        this.drawerDirection = this.defaults.drawerDirection;
        this.displayModal = this.defaults.displayModal;
        this.moneyFormat = this.defaults.moneyFormat;
        this.labelAddedToCart = this.defaults.labelAddedToCart;
        this.labelCartIsEmpty = this.defaults.labelCartIsEmpty;
        this.labelQuantity = this.defaults.labelQuantity;
        this.labelRemove = this.defaults.labelRemove;
        this.hiddenItemTag = this.defaults.hiddenItemTag;

        this.init();

    }

    get isDrawerMode() {
        return this.cartMode === 'drawer';
    }

    init() {

        this.fetchCart();

        if (this.isDrawerMode) {
            this.setDrawerDirection();
        }

        /*
        document.addEventListener('click', (event) => {
            if (event.target.matches(this.defaults.addToCart)) {
                event.preventDefault();
                let item = event.target;
                let form = item.parentNode;
                while ('form' !== form.tagName.toLowerCase()) {
                    form = form.parentNode;
                }
                const formID = form.getAttribute('id');
                this.addItemToCart(formID);
            }
        }, false);
        */

        if (this.addToCart) { 
            this.addToCart.forEach((item) => {
                item.addEventListener('click', (event) => {
                    event.preventDefault();
                    let form = item.parentNode;
                    while ('form' !== form.tagName.toLowerCase()) {
                        form = form.parentNode;
                    }
                    const formID = form.getAttribute('id');
                    this.addItemToCart(formID);
                });
            });
        }

        this.cartTrigger.forEach((item) => {
            item.addEventListener('click', () => {
                if (this.isDrawerMode) {
                    this.openCartDrawer();
                } else {
                    this.openMiniCart();
                }
                this.openCartOverlay();
            });
        });


        this.cartOverlay.addEventListener('click', () => {
            this.closeFailModal();
            this.closeCartModal();
            if (this.isDrawerMode) {
                this.closeCartDrawer();
            } else {
                this.closeMiniCart();
            }
            this.closeCartOverlay();
        });

        if (this.isDrawerMode) {
            this.cartDrawerClose.addEventListener('click', () => {
                this.closeCartDrawer();
                this.closeCartOverlay();
            });
        }

        if (this.displayModal) {
            this.cartModalClose.forEach((item) => {
                item.addEventListener('click', () => {
                    this.closeFailModal();
                    this.closeCartModal();
                    if (this.isDrawerMode) {
                        this.closeCartDrawer();
                    } else {
                        this.closeMiniCart();
                    }
                    this.closeCartOverlay();
                });
            });
        }

        this.cartModalFailClose.addEventListener('click', () => {
            this.closeFailModal();
            this.closeCartModal();
            if (this.isDrawerMode) {
                this.closeCartDrawer();
            } else {
                this.closeMiniCart();
            }
            this.closeCartOverlay();
        });

    }

    fetchCart(callback) {
        window.fetch('/cart?view=json', {
            credentials: 'same-origin',
            method: 'GET',
        })
            .then((response) => response.text())
            .then((cart) => { eval(cart); this.fetchHandler(window.cart, callback)})
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    addItemToCart(formID) {
        const isObjectEmpty = (objectName) => {
            return Object.keys(objectName).length === 0 && objectName.constructor === Object;
        }
        const form = document.querySelector(`#${formID}`);
        const sellingPlan = document.querySelector('input[name="selling_plan"]');
        let formData;
        if (sellingPlan && sellingPlan.value !== '') {
            formData = {
                'id': document.querySelector('input.product-variant-id').value,
                'quantity': document.getElementById('Quantity').value,
                'selling_plan': sellingPlan.value
            };
        }
        else {
            formData = {
                'id': document.querySelector('input.product-variant-id').value,
                'quantity': document.getElementById('Quantity').value
            };
        }

        const resetQuantityField = () => {
            let quantity = document.getElementById('Quantity');
            if (quantity) {
                quantity.value = 1;
            }
        }
        window.fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((product) => this.addItemToCartHandler(product))
            .then(() => resetQuantityField())
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    removeItem(line) {
        const quantity = 0;
        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({quantity, line}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then(() => this.fetchCart())
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    changeItemQuantity(line, quantity) {
        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({quantity, line}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then(() => this.fetchCart())
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    cartItemCount(cart) {
        // this.cartCount.innerHTML = cart.item_count;
        this.cartCount.forEach((item) => {
            item.innerHTML = cart.item_count;
        });
    }

    fetchAndOpenCart() {
        this.fetchCart(() => {
            if (this.isDrawerMode) {
                this.openCartDrawer();
            } else {
                this.openMiniCart();
            }
            this.openCartOverlay();
        });
    }

    fetchAndOpenModal(product) {
        this.fetchCart(() => {
            this.renderCartModal(product);
            this.openCartModal();
            this.openCartOverlay();
        });
    }

    fetchHandler(cart, callback) {
        this.cartItemCount(cart);
        if (this.isDrawerMode) {
            if (cart.item_count === 0) {
                this.renderBlankCartDrawer();
                this.cartDrawerFooter.classList.add('is-invisible');
            } else {
                this.renderDrawerCart(cart);
                this.cartDrawerFooter.classList.remove('is-invisible');
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
            }
        } else if (cart.item_count === 0) {
            this.renderBlankMiniCart();
            this.cartMiniCartFooter.classList.add('is-invisible');
        } else {
            this.renderMiniCart(cart);
            this.cartMiniCartFooter.classList.remove('is-invisible');
            if ((typeof callback) === 'function') {
                callback(cart);
            }
        }
    }

    addItemToCartHandler(product) {
        return this.displayModal ? this.fetchAndOpenModal(product) : this.fetchAndOpenCart();
    }

    ajaxRequestFail() {
        this.openFailModal();
        this.openCartOverlay();
    }

    renderCartModal(product) {
        this.clearCartModal();
        let productVariant = product.variant_title;
        if (productVariant === null) {
            productVariant = '';
        } else {
            productVariant = `(${productVariant})`;
        }
        const cartSingleProduct = `
          <div class="go-cart-modal-item">
            <div class="go-cart-item__image" style="background-image: url(${product.image});"></div>
            <div class="go-cart-item__info">
              ${product.product_title.includes(this.hiddenItemTag) ? 
              `<p class="go-cart-item__title">${product.product_title} ${productVariant}</p>` : 
              `<a href="${product.url}" class="go-cart-item__title">${product.product_title} ${productVariant}</a>`}
              ${this.labelAddedToCart}
            </div>
          </div>`;
        this.cartModalContent.innerHTML += cartSingleProduct;
    }

    renderDrawerCart(cart) {
        let rebuy = this.getCartRebuyContent();
        this.clearCartDrawer();
        console.log('cart ', cart)
        this.renderBundleContent(cart);
        cart.items.forEach((item, index) => {
            if (!item.properties["_rc_bundle"]) {
                let itemVariant = item.variant_title;
                if (itemVariant === null) {
                    itemVariant = '';
                }
                var selling_plan_id='';
                if (item.selling_plan_allocation) {
                    selling_plan_id = item.selling_plan_allocation.selling_plan.id;
                }
              console.log(item.final_line_price, item, item.final_line_price == 0);
                
              if(item.final_line_price != 0)
              {
let upgrade_widget = `<div data-upgradeable-item data-line-item-product="${item.product_id}" data-line-item-key="${item.variant_id}" data-line="${Number(index + 1)}" data-selling-plan="${selling_plan_id}" data-quantity="${item.quantity}"></div>`;
                const cartSingleProduct = `
                <div class="go-cart-item__single" data-line="${Number(index + 1)}">
                    <div class="go-cart-item__info-wrapper">
                    <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
                    <div class="go-cart-item__info">
                        ${item.product_tags.includes(this.hiddenItemTag) ? 
                        `<p class="go-cart-item__title h4">${item.product_title}</p>` : 
                        `<a href="${item.url}" class="go-cart-item__title h4">${item.product_title}</a>`}
                        <div class="go-cart-item__variant body1">${itemVariant}</div>
                        ${upgrade_widget}
                        <div class="go-cart-price-qty body1">
                        <div class="go-cart-item__price body1">${formatMoney(item.line_price, this.moneyFormat)}</div>
                        <div class="go-cart-item__quantity body1">
                            ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>`}
                            <input class="go-cart-item__quantity-number js-go-cart-quantity body1" type="number" value="${item.quantity}" disabled>
                            ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>`}
                        </div>
                        </div>
                        
                    </div>
                    
                    </div>
                    
                    <a class="go-cart-item__remove ${this.removeFromCartNoDot}"><i class="icon-remove cart-remove"></i></a>
                </div>`;
                this.cartDrawerContent.innerHTML += cartSingleProduct;
              } else {
                let upgrade_widget = `<div class="zero-price-line-item" data-upgradeable-item data-line-item-product="${item.product_id}" data-line-item-key="${item.variant_id}" data-line="${Number(index + 1)}" data-selling-plan="${selling_plan_id}" data-quantity="${item.quantity}"></div>`;
                const cartSingleProduct = `
                <div class="go-cart-item__single" data-line="${Number(index + 1)}">
                    <div class="go-cart-item__info-wrapper">
                    <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
                    <div class="go-cart-item__info">
                        ${item.product_tags.includes(this.hiddenItemTag) ? 
                        `<p class="go-cart-item__title h4">${item.product_title}</p>` : 
                        `<a href="${item.url}" class="go-cart-item__title h4">${item.product_title}</a>`}
                        <div class="go-cart-item__variant body1">${itemVariant}</div>
                        ${upgrade_widget}
                        <div class="go-cart-price-qty body1">
                        <div class="go-cart-item__price body1">Free gift with purchase</div>
                        
                        </div>
                        
                    </div>
                    
                    </div>
                    
                    <a class="go-cart-item__remove ${this.removeFromCartNoDot}"><i class="icon-remove cart-remove"></i></a>
                </div>`;
                this.cartDrawerContent.innerHTML += cartSingleProduct;
              console.log('here', item);
                console.log("price more than 0");
              }
                
            }
        });
        
        this.cartDrawerSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
        this.cartDrawerSubTotal.parentNode.classList.remove('is-invisible');
        const removeFromCart = document.querySelectorAll(this.removeFromCart);
        removeFromCart.forEach((item) => {
            item.addEventListener('click', () => {
                GoCart.removeItemAnimation(item.parentNode);
                const line = item.parentNode.getAttribute('data-line');
                this.removeItem(line);
            });
        });
        const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
        itemQuantityPlus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
                this.changeItemQuantity(line, quantity);
            });
        });
        const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
        itemQuantityMinus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
                this.changeItemQuantity(line, quantity);
                if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                    GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
                }
            });
        });
        this.appendRebuyContent(rebuy);
        this.updateShippingMotivator();
        document.dispatchEvent(new CustomEvent("CartUpdated",{bubbles:true,detail:cart}));
    }

    renderMiniCart(cart) {
        this.clearMiniCart();
        this.renderBundleContent(cart);
        cart.items.forEach((item, index) => {
            let itemVariant = item.variant_title;
            if (itemVariant === null) {
                itemVariant = '';
            }
            const cartSingleProduct = `
              <div class="go-cart-item__single" data-line="${Number(index + 1)}">
                <div class="go-cart-item__info-wrapper">
                    <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
                    <div class="go-cart-item__info">
                        ${item.product_tags.includes(this.hiddenItemTag) ? 
                        `<p class="go-cart-item__title h3">${item.product_title}</p>` : 
                        `<a href="${item.url}" class="go-cart-item__title h3">${item.product_title}</a>`}
                        <div class="go-cart-item__variant">${itemVariant}</div>
                        <div class="go-cart-item__quantity">
                          ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>`}
                          <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${item.quantity}" disabled>
                          ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>`}
                        </div>
                    </div>
                </div>
                <div class="go-cart-item__price">${formatMoney(item.line_price, this.moneyFormat)}</div>
                <a class="go-cart-item__remove ${this.removeFromCartNoDot}">${this.labelRemove}</a>
              </div>`;
            this.cartMiniCartContent.innerHTML += cartSingleProduct;
        });
        this.cartMiniCartSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
        this.cartMiniCartSubTotal.parentNode.classList.remove('is-invisible');
        const removeFromCart = document.querySelectorAll(this.removeFromCart);
        removeFromCart.forEach((item) => {
            item.addEventListener('click', () => {
                GoCart.removeItemAnimation(item.parentNode);
                const line = item.parentNode.getAttribute('data-line');
                this.removeItem(line);
            });
        });
        const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
        itemQuantityPlus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
                this.changeItemQuantity(line, quantity);
            });
        });
        const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
        itemQuantityMinus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
                this.changeItemQuantity(line, quantity);
                if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                    GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
                }
            });
        });
    }

    renderBlankCartDrawer() {
        let rebuy = this.getCartRebuyContent();
        this.cartDrawerSubTotal.parentNode.classList.add('is-invisible');
        this.clearCartDrawer();
        this.cartDrawerContent.innerHTML = `<div class="go-cart__empty body1">${this.labelCartIsEmpty}</div>`;
        this.appendRebuyContent(rebuy);
        this.updateShippingMotivator();
    }

    renderBlankMiniCart() {
        this.cartMiniCartSubTotal.parentNode.classList.add('is-invisible');
        this.clearMiniCart();
        this.cartMiniCartContent.innerHTML = `<div class="go-cart__empty body1">${this.labelCartIsEmpty}</div>`;
    }

    async renderBundleContent(cart) {
        var self = this;
        // Initialize variables
        let rc_displayed_bundles = "";
        let rc_bundles = "";
        let rc_bundles_cart_count = cart.item_count;
        let rc_bundles_count = 0;
        let rc_bundles_item_count = 0;

        // Iterate through cart items
        cart.items.forEach(function(item) {
            // Check if "_rc_bundle" property exists in item.properties
            if (item.properties && item.properties["_rc_bundle"]) {
              // Check if the bundle has already been added
              if (!rc_bundles.includes(item.properties["_rc_bundle"])) {
                rc_bundles += "," + item.properties["_rc_bundle"];
                rc_bundles_count++;
              }
          
              rc_bundles_item_count += item.quantity;
            }
        });
          
        // Remove leading comma from rc_bundles
        rc_bundles = rc_bundles.replace(/^,/, "");

        // Calculate rc_bundles_cart_count
        rc_bundles_cart_count = rc_bundles_cart_count - rc_bundles_item_count + rc_bundles_count;

        for (const item of cart.items) {
            if(rc_bundles.includes(item.properties["_rc_bundle"])) {
                if(!rc_displayed_bundles.includes(item.properties["_rc_bundle"])) {
                    // Initialize variables
                    let rc_bundle_id =  item.properties["_rc_bundle"];
                    let rc_bundle_price = 0;
                    let rc_bundle_original_price = 0;
                    let rc_bundle_selling_plan_allocation_compare_at_price = 0;
                    let rc_bundle_product = {};
                    let rc_bundle_contents = "";
                    let rc_bundle_handle = "";
                    let rc_bundle_url_to_remove = "/cart/update?";
                    let rc_bundle_variant = "";
                    let rc_bundle_variant_id = "";

                    // Iterate through cart items
                    cart.items.forEach(function(item) {
                        if (item.properties["_rc_bundle"] === rc_bundle_id) {
                            rc_bundle_price += item.final_line_price;
                            rc_bundle_original_price += item.original_line_price;

                            rc_bundle_contents += ", " + item.quantity + 'x ' + item.title;

                            const selling_plan_allocation_compare_at_price_total =
                            (item?.selling_plan_allocation?.compare_at_price || 0) * item.quantity;

                            rc_bundle_selling_plan_allocation_compare_at_price +=
                            selling_plan_allocation_compare_at_price_total;

                            rc_bundle_handle = item.properties["_rc_bundle_parent"];
                            rc_bundle_variant_id = Number(item.properties["_rc_bundle_variant"]);

                            rc_bundle_url_to_remove += `updates[${item.key}]=0&`;
                        }
                    });

                    // Fetch the product using the Shopify AJAX API
                    if(rc_bundle_handle) {
                        try {
                            const response = await fetch(`/products/${rc_bundle_handle}.js`);
                            const productData = await response.json();
            
                            if (productData) {
                                rc_bundle_product = productData;
                                // Remove leading comma from rc_bundle_contents
                                rc_bundle_contents = rc_bundle_contents.replace(/^, /, "");

                                // Add rc_bundle_id to rc_displayed_bundles
                                rc_displayed_bundles += "," + rc_bundle_id;

                                // Find the matching variant using rc_bundle_variant_id
                                rc_bundle_product.variants.forEach(function(variant) {
                                    if (variant.id === rc_bundle_variant_id) {
                                        rc_bundle_variant = variant;
                                    }
                                });
                                console.log('rc_bundle_variant ', rc_bundle_variant)
                                
                                const cartSingleProduct = `
                                <div class="go-cart-item__single bundle_item" data-line="bundle line">
                                    <div class="go-cart-item__info-wrapper">
                                        <div class="go-cart-item__image" style="background-image: url(${rc_bundle_product.images[0]});"></div>
                                        <div class="go-cart-item__info">
                                            <a href="${rc_bundle_product.url}" class="go-cart-item__title h4">${rc_bundle_product.title}</a>
                                            ${rc_bundle_variant?.title.includes('Default Variant') ? 
                                                `` : 
                                                `<div class="go-cart-item__variant">${rc_bundle_variant?.title}</div>`
                                            }
                                            <p class="body1 bundle-contents">Contents: ${rc_bundle_contents}</p>
                                            <div class="go-cart-item__quantity">
                                            
                                            <input class="d-none go-cart-item__quantity-number js-go-cart-quantity" type="number" value="1" disabled>
                                            
                                            </div>
                                        </div>
                                    </div>
                                   <div class="bundle-discount-price-wrapper">
                                    ${rc_bundle_original_price !== rc_bundle_price ? 
                                        `<span class="cart-item-original-price"><s>${formatMoney(rc_bundle_original_price, self.moneyFormat)}</s></span>` : 
                                        ``
                                    }
                                    ${item.discounts.map(discount => `
                                        <span class="cart-item-discount body1 em">
                                            ${discount.title}
                                        </span>`
                                    ).join('')}
                                     </div>
                                     <div class="go-cart-item__price">${formatMoney(rc_bundle_price, self.moneyFormat)}</div>

                                    <a class="go-cart-item__remove" href="${rc_bundle_url_to_remove}">${self.labelRemove}</a>
                                </div>`;
                                self.cartDrawerContent.insertAdjacentHTML('afterbegin', cartSingleProduct);
                            }
                        } catch (error) {
                            console.error('Error fetching product data:', error);
                        }
                    }
                    
                }
            }
        }
    }

    reloadAjaxContent() {
      this.fetchAndOpenCart();
    }

    clearCartDrawer() {
        this.cartDrawerContent.innerHTML = '';
    }

    clearMiniCart() {
        this.cartMiniCartContent.innerHTML = '';
    }

    clearCartModal() {
        this.cartModalContent.innerHTML = '';
    }

    openCartDrawer() {
        this.cartDrawer.classList.add('is-open');
    }

    closeCartDrawer() {
        this.cartDrawer.classList.remove('is-open');
    }

    openMiniCart() {
        this.cartMiniCart.classList.add('is-open');
    }

    closeMiniCart() {
        this.cartMiniCart.classList.remove('is-open');
    }

    openFailModal() {
        this.cartModalFail.classList.add('is-open');
    }

    closeFailModal() {
        this.cartModalFail.classList.remove('is-open');
    }

    openCartModal() {
        this.cartModal.classList.add('is-open');
    }

    closeCartModal() {
        this.cartModal.classList.remove('is-open');
    }

    openCartOverlay() {
        this.cartOverlay.classList.add('is-open');
    }

    closeCartOverlay() {
        this.cartOverlay.classList.remove('is-open');
    }

    static removeItemAnimation(item) {
        item.classList.add('is-invisible');
    }

    setDrawerDirection() {
        this.cartDrawer.classList.add(`go-cart__drawer--${this.drawerDirection}`);
    }

    getCartRebuyContent() {
                let ret = [];
                document.querySelector(".js-go-cart-drawer-content").querySelectorAll("[data-rebuy-id]").forEach(node=>{
                        ret.push(node);
                        node.parentNode.removeChild(node);
                });
                return ret;
        }
  appendRebuyContent(content) {
    let gcc = document.querySelector(".js-go-cart-drawer-content");
    content.forEach(node=>gcc.appendChild(node));
    
  }
  updateShippingMotivator() { 
        const freeShippingContainer = document.querySelector('.js-go-cart-drawer__shipping-message');
        if (freeShippingContainer) {
                        const threshold = parseInt(freeShippingContainer.getAttribute('data-free-shipping-amount'));
                        if ( window.cart.total_price < threshold ) {
                                document.querySelector('.go-cart-drawer__shipping-away').style.display = 'block';
                                document.querySelector('.go-cart-drawer__shipping-meter').style.display = 'block';

                                let leftAmount = threshold - window.cart.total_price;
                                let freeShippingAwayContainer = document.querySelector('.go-cart-drawer__shipping-away');
                                let freeShippingAwayMessage = freeShippingAwayContainer.getAttribute('data-template');
                                freeShippingAwayMessage = freeShippingAwayMessage.replace('##', `<strong>${formatMoney(leftAmount, this.moneyFormat)}</strong>`);
                                freeShippingAwayContainer.innerHTML = freeShippingAwayMessage;

                                leftAmount = parseInt(leftAmount * 100 / threshold);
                                document.querySelector('.go-cart-drawer__shipping-fill').style.width = `${100 - leftAmount}%`;
                                //document.querySelector('.go-cart-drawer__shipping-fill').innerHTML = `${100 - leftAmount}%`;
                        } else { 
                let freeShippingAwayContainer = document.querySelector('.go-cart-drawer__shipping-away');
                freeShippingAwayContainer.innerHTML = freeShippingAwayContainer.getAttribute("data-threshold-met");
                                //document.querySelector('.go-cart-drawer__shipping-away').style.display = 'none';
                                document.querySelector('.go-cart-drawer__shipping-meter').style.display = 'none';
                        }
                }
        }

updateShippingMotivator() {
        const freeShippingContainer = document.querySelector('.js-go-cart-drawer__shipping-message');
        if (freeShippingContainer) {
                        const threshold = parseInt(freeShippingContainer.getAttribute('data-free-shipping-amount'));
                        if ( window.cart.total_price < threshold ) {
                                document.querySelector('.go-cart-drawer__shipping-away').style.display = 'block';
                                document.querySelector('.go-cart-drawer__shipping-meter').style.display = 'block';

                                let leftAmount = threshold - window.cart.total_price;
                                let freeShippingAwayContainer = document.querySelector('.go-cart-drawer__shipping-away');
                                let freeShippingAwayMessage = freeShippingAwayContainer.getAttribute('data-template');
                                freeShippingAwayMessage = freeShippingAwayMessage.replace('##', `<strong>${formatMoney(leftAmount, this.moneyFormat)}</strong>`);
                                freeShippingAwayContainer.innerHTML = freeShippingAwayMessage;

                                leftAmount = parseInt(leftAmount * 100 / threshold);
                                document.querySelector('.go-cart-drawer__shipping-fill').style.width = `${100 - leftAmount}%`;
                                //document.querySelector('.go-cart-drawer__shipping-fill').innerHTML = `${100 - leftAmount}%`;
                        } else {
                let freeShippingAwayContainer = document.querySelector('.go-cart-drawer__shipping-away');
                freeShippingAwayContainer.innerHTML = freeShippingAwayContainer.getAttribute("data-threshold-met");
                                //document.querySelector('.go-cart-drawer__shipping-away').style.display = 'none';
                                document.querySelector('.go-cart-drawer__shipping-meter').style.display = 'none';
                        }
                }
        }


}

//export default GoCart;

